import React from 'react'
import AnimateOnScroll from '../components/ScrollAnimations/AnimateOnScroll'
import Button2 from '../components/Buttons/Button2/Button2'
import { useParams } from 'react-router-dom'

const EventsDetails = () => {
    const { eventUrl } = useParams();
    return (
        <>
            <div className="events container">
                <AnimateOnScroll>
                    <p className="base_heading_2">
                        How about learning some new stuffs?
                    </p>
                    {/* <p className="base_heading_2" id="words" style={{ opacity: fade ? 1 : 0, transition: 'opacity 0.5s ease-in-out' }}>{words[currentIndex]}</p> */}
                    <p className="base_p_tag">
                        More than aesthetics. We build high-converting websites that speak to your audience and drive real business growth.
                    </p>
                </AnimateOnScroll>

                <AnimateOnScroll>
                    <Button2 text="Explore Our Services" link="/services" />
                </AnimateOnScroll>

            </div>
            <div className="event-details-page">
                <p className="base_heading_2">
                    How about learning some new stuffs? - { eventUrl }
                </p>
            </div>
        </>
    )
}

export default EventsDetails